/* eslint-disable security/detect-object-injection */
import { IGlobalActions, VSConfiguration } from '@bees-web/core/types'
import {
  GLOBAL_TRACKABLE_ACTIONS,
  globalActions,
  globalComponents,
} from '@bees-web/nfa-interactive-global'
import { deepMerge } from '../../deepMerge'

let _trackableActions: Set<string> = null
let _publicActions: IGlobalActions = null
let _customComponents: Record<string, unknown> = {}

export type SetTrackableActions = (modules: Record<string, VSConfiguration>) => {
  trackableActions: Set<string>
  publicActions: IGlobalActions
  components: Record<string, unknown>
}

export type GetTrackableActions = () => Set<string>

export type GetPublicActions = () => IGlobalActions

export const setSharedContext: SetTrackableActions = (modules) => {
  const actions: IGlobalActions = {}
  const trackableActions: string[] = []
  const components: Record<string, unknown> = {}

  Object.keys(modules).forEach((key) => {
    if (modules[key].redux) {
      const { public: publicActions = {}, trackables = [] } = modules[key].redux.actions
      actions[key] = publicActions
      trackableActions.push(...trackables)
    }
    components[key] = modules[key].components
  })
  _publicActions = actions
  _trackableActions = new Set<string>([
    ...Object.values(GLOBAL_TRACKABLE_ACTIONS),
    ...trackableActions,
  ])
  _customComponents = {
    global: globalComponents,
    ...components,
  }
  return {
    trackableActions: _trackableActions,
    publicActions: _publicActions,
    components: _customComponents,
  }
}

export const getTrackableActions: GetTrackableActions = () =>
  _trackableActions || new Set<string>(Object.values(GLOBAL_TRACKABLE_ACTIONS))

export const getGlobalActions = (): IGlobalActions =>
  deepMerge(_publicActions, globalActions)

export type GetCustomComponent = (name: string) => unknown

export const getCustomComponent: GetCustomComponent = (name) => {
  const parts = name?.split('.') || []
  const [namespace, componentName] = parts

  if (parts.length === 2) {
    const components = _customComponents[namespace]
    const component = components?.[componentName]
    return component || null
  } else {
    console.error(`Component address '${name}' is not a valid address`)
  }

  return undefined
}
